import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'highlight',
})
export class HighlightPipe implements PipeTransform {
  transform(value: string | null, cssClasses?: string, stripHighlight?: boolean): string {
    if (!value) {
      return '';
    }
    // To only remove []
    if (stripHighlight) {
      return (value || '').replace(/\[(.*?)\]/g, `$1`);
    }

    // [YOURSTRING] wrap in span
    return (value || '').replace(/\[(.*?)\]/g, `<span class="${cssClasses || 'text-primary'}">$1</span>`);
  }
}
